export const When = ({ children, condition = false }) => {
  return condition ? children : null
}
